var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.project.detail && _vm.project.detail.id)?_c('div',[_c('ProjectSimpleEditComponent')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }